import { useState, useCallback } from "react";

export const useCameraViewpoints = () => {
  const [cameraViewpoints, setCameraViewpoints] = useState([]);
  const [cameraViewpointsLoading, setCameraViewpointsLoading] = useState(false);

  const fetchCameraViewpoints = useCallback(async (video, allFilesData) => {
    if (!video || !video.filename) return;

    setCameraViewpointsLoading(true);

    try {
      if (!allFilesData || allFilesData.length === 0) {
        setCameraViewpoints([]);
        return;
      }

      const parseTimestamp = (filename) => {
        const parts = filename.replace(".mp4", "").replace(".MP4", "").split("_");
        if (parts.length < 6) return null;

        const year = parseInt(parts[0]);
        const month = parseInt(parts[1]) - 1;
        const day = parseInt(parts[2]);
        const hour = parseInt(parts[3]);
        const minute = parseInt(parts[4]);
        const second = parseInt(parts[5]);

        return new Date(year, month, day, hour, minute, second);
      };

      const isWithinRange = (targetDate, compareFilename) => {
        const compareDate = parseTimestamp(compareFilename);
        if (!targetDate || !compareDate) return false;

        const diffInSeconds = Math.abs((targetDate - compareDate) / 1000);
        return diffInSeconds <= 150; // ±2.5 minutes
      };

      const selectedTimestamp = parseTimestamp(video.filename);

      const matchingFiles = allFilesData.filter(
        (f) =>
          isWithinRange(selectedTimestamp, f.filename) &&
          f.path &&
          f.path.includes("/Sensor_1/") &&
          f.thumbnailToken
      );

      const viewpointsData = matchingFiles.map((file) => {
        const fileTimestamp = parseTimestamp(file.filename);
        const timeDiff = Math.abs((selectedTimestamp - fileTimestamp) / 1000);

        const moduleMatch = file.path.match(/\/Module_(\d+)\//);
        const moduleNum = moduleMatch ? parseInt(moduleMatch[1]) : 0;

        return {
          id: file.id,
          module_id: moduleNum,
          module: `Module ${moduleNum}`,
          videoToken: file.videoToken,
          thumbnailToken: file.thumbnailToken,
          filename: file.filename,
          size: file.size,
          path: file.path,
          timeDiff: timeDiff,
        };
      });

      viewpointsData.sort((a, b) => {
        if (a.module_id !== b.module_id) {
          return a.module_id - b.module_id;
        }
        return a.timeDiff - b.timeDiff;
      });

      setCameraViewpoints(viewpointsData);
    } catch (error) {
      console.error("Failed to fetch camera viewpoints:", error);
      setCameraViewpoints([]);
    } finally {
      setCameraViewpointsLoading(false);
    }
  }, []);

  return {
    cameraViewpoints,
    setCameraViewpoints,
    cameraViewpointsLoading,
    fetchCameraViewpoints,
  };
};

